var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-group" },
    [
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyName" } },
        [
          _vm._v(
            _vm._s(_vm.resource("JourneyBuilderPublishModel_Name_DisplayName"))
          )
        ]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.journeyNameModel,
            expression: "journeyNameModel"
          }
        ],
        staticClass: "form-control",
        attrs: {
          "data-val": "true",
          "data-val-required": "Het veld naam is verplicht",
          id: "JourneyName",
          name: "JourneyName",
          type: "text",
          disabled: !_vm.canWrite
        },
        domProps: { value: _vm.journeyNameModel },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.journeyNameModel = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _vm.$v.journeyNameModel.$dirty && _vm.$v.journeyNameModel.$invalid
        ? [
            !_vm.$v.journeyNameModel.required
              ? _c("required-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "JourneyBuilderPublishModel_Name_DisplayName"
                    )
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.journeyNameModel.maxLength
              ? _c("max-length-error-message", {
                  attrs: {
                    "field-name": _vm.resource(
                      "JourneyBuilderPublishModel_Name_DisplayName"
                    ),
                    "max-length": 255
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("br")
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "span",
        { ref: "activateToggle" },
        [
          _c("toggle-button", {
            attrs: {
              value: _vm.journeyIsActive,
              sync: true,
              labels: {
                checked: _vm.resource("Bool_Active"),
                unchecked: _vm.resource("Bool_Inactive")
              },
              width: 78,
              disabled: !_vm.hasActivationPermission
            },
            on: {
              change: function($event) {
                return _vm.$emit("update:journeyIsActive", $event.value)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyWorld" } },
        [
          _vm._v(
            _vm._s(_vm.resource("JourneyBuilderPublishModel_World_DisplayName"))
          )
        ]
      ),
      _vm._v(" "),
      _vm.journeyWorlds.length > 0
        ? _c(
            "v-select",
            {
              staticClass: "form-control",
              attrs: {
                options: _vm.journeyWorlds,
                label: "name",
                clearable: true,
                searchable: "",
                filterable: "",
                taggable: "",
                "close-on-select": "",
                disabled: !_vm.canWrite
              },
              model: {
                value: _vm.worldModel,
                callback: function($$v) {
                  _vm.worldModel = $$v
                },
                expression: "worldModel"
              }
            },
            [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyType" } },
        [
          _vm._v(
            _vm._s(_vm.resource("JourneyBuilderPublishModel_Type_DisplayName"))
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "v-select",
        {
          staticClass: "form-control",
          attrs: {
            options: _vm.journeyTypes,
            label: "name",
            clearable: false,
            taggable: "",
            "close-on-select": "",
            disabled: !_vm.canWrite
          },
          model: {
            value: _vm.typeModel,
            callback: function($$v) {
              _vm.typeModel = $$v
            },
            expression: "typeModel"
          }
        },
        [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "control-label",
          attrs: { for: "journey-division-dropdown" }
        },
        [
          _vm._v(
            _vm._s(
              _vm.resource("JourneyBuilderPublishModel_DivisionId_DisplayName")
            )
          )
        ]
      ),
      _vm._v(" "),
      _vm.divisionList
        ? [
            _c("division-dropdown", {
              attrs: {
                "division-list": _vm.divisionList,
                id: "journey-division-dropdown",
                disabled: !_vm.canWrite
              },
              model: {
                value: _vm.journeyDivisionIdModel,
                callback: function($$v) {
                  _vm.journeyDivisionIdModel = $$v
                },
                expression: "journeyDivisionIdModel"
              }
            })
          ]
        : [_c("select", { staticClass: "form-control" })],
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyStartDate" } },
        [
          _vm._v(
            _vm._s(
              _vm.resource("JourneyBuilderPublishModel_StartDate_DisplayName")
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("datepicker", {
        attrs: {
          id: "JourneyStartDate",
          name: "JourneyStartDate",
          value: _vm.startDate,
          options: _vm.startDatePickerOptions
        },
        on: { input: _vm.updateStartDate }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyEndDate" } },
        [
          _vm._v(
            _vm._s(
              _vm.resource("JourneyBuilderPublishModel_EndDate_DisplayName")
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("datepicker", {
        attrs: {
          id: "JourneyEndDate",
          name: "JourneyEndDate",
          value: _vm.endDate,
          options: _vm.endDatePickerOptions
        },
        on: { input: _vm.updateEndDate }
      }),
      _vm._v(" "),
      _c(
        "label",
        { staticClass: "control-label", attrs: { for: "JourneyDescription" } },
        [
          _vm._v(
            _vm._s(
              _vm.resource("JourneyBuilderPublishModel_Description_DisplayName")
            )
          )
        ]
      ),
      _vm._v(" "),
      _c("textarea", {
        staticClass: "form-control",
        attrs: { rows: "7", id: "JourneyDescription", disabled: !_vm.canWrite },
        domProps: { value: _vm.journeyDescription },
        on: {
          change: function($event) {
            return _vm.$emit("update:journeyDescription", $event.target.value)
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }